'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRhumb = require('react-rhumb');

var _BannerSection = require('pricing-pages-unified-ui/components/banners/BannerSection');

var _BannerSection2 = _interopRequireDefault(_BannerSection);

var _CurrencyPicker = require('pricing-pages-unified-ui/components/common/CurrencyPicker');

var _CurrencyPicker2 = _interopRequireDefault(_CurrencyPicker);

var _FooterMicrocopy = require('pricing-pages-unified-ui/components/common/FooterMicrocopy');

var _FooterMicrocopy2 = _interopRequireDefault(_FooterMicrocopy);

var _ProductsAndPlansNavIds = require('pricing-pages-unified-ui/constants/ProductsAndPlansNavIds');

var _ProductsAndPlansNavIds2 = _interopRequireDefault(_ProductsAndPlansNavIds);

var _CustomerSupport = require('pricing-pages-unified-ui/static/js/components/common/CustomerSupport');

var _CustomerSupport2 = _interopRequireDefault(_CustomerSupport);

var _Tracking = require('../../constants/Tracking');

var _getUsageTracker = require('../../utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _TabLayout = require('../TabLayout');

var _TabLayout2 = _interopRequireDefault(_TabLayout);

var _CmsInfo = require('../product-pages/CmsInfo');

var _CmsInfo2 = _interopRequireDefault(_CmsInfo);

var _StyledBlob = require('../common/StyledBlob');

var _StyledBlob2 = _interopRequireDefault(_StyledBlob);

var _PageContainer = require('../common/PageContainer');

var _PageContainer2 = _interopRequireDefault(_PageContainer);

var _HubInfoContainer = require('../common/HubInfoContainer');

var _HubInfoContainer2 = _interopRequireDefault(_HubInfoContainer);

var _Faq = require('pricing-pages-unified-ui/static/js/components/common/Faq');

var _Faq2 = _interopRequireDefault(_Faq);

var _Question = require('pricing-pages-unified-ui/static/js/components/common/Question');

var _Question2 = _interopRequireDefault(_Question);

var _urls = require('pricing-pages-unified-ui/utils/urls');

var _DocumentUtils = require('pricing-pages-unified-ui/static/js/utils/DocumentUtils');

var _PhoneSupportFooter = require('pricing-pages-unified-ui/components/common/PhoneSupportFooter');

var _PhoneSupportFooter2 = _interopRequireDefault(_PhoneSupportFooter);

var _FailedLoadBanner = require('pricing-pages-unified-ui/components/loading/FailedLoadBanner');

var _FailedLoadBanner2 = _interopRequireDefault(_FailedLoadBanner);

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CMS = _ProductsAndPlansNavIds2.default.CMS;


function CmsPage(_ref) {
  var purchaseMotionRequestStatus = _ref.purchaseMotionRequestStatus;

  (0, _react.useEffect)(function () {
    (0, _getUsageTracker2.default)().track('pageView', {
      screen: _Tracking.SCREENS.PRODUCTS_PLANS,
      subscreen: _Tracking.SUBSCREENS.CMS
    });
  }, []);

  return _react2.default.createElement(
    _TabLayout2.default,
    { selectedPrimaryTab: 'products', selectedSecondaryTab: 'cms' },
    _react2.default.createElement(
      _PageContainer2.default,
      { 'data-selenium-id': 'page-success' },
      purchaseMotionRequestStatus === _RequestStatusTypes2.default.SUCCEEDED && _react2.default.createElement(_reactRhumb.NavMarker, { name: 'CMS_PAGE' }),
      _react2.default.createElement(_CurrencyPicker2.default, null),
      _react2.default.createElement(_StyledBlob2.default, null),
      _react2.default.createElement(
        _HubInfoContainer2.default,
        null,
        _react2.default.createElement(_FailedLoadBanner2.default, {
          hasFailed: purchaseMotionRequestStatus === _RequestStatusTypes2.default.FAILED
        }),
        _react2.default.createElement(_BannerSection2.default, { hub: CMS, hasTitleComponent: false }),
        _react2.default.createElement(_CmsInfo2.default, null),
        _react2.default.createElement(
          'div',
          { style: { margin: '32px auto' } },
          _react2.default.createElement(_CustomerSupport2.default, null)
        ),
        _react2.default.createElement(
          _Faq2.default,
          null,
          _react2.default.createElement(_Question2.default, { questionKey: 'cms.cmsOnboarding' }),
          _react2.default.createElement(_Question2.default, {
            questionKey: 'cms.cmsProductLimits',
            href: (0, _urls.getProductsAndServicesCatalogUrl)()
          }),
          _react2.default.createElement(_Question2.default, { questionKey: 'cms.cmsRelationship' }),
          _react2.default.createElement(_Question2.default, { questionKey: 'cms.cmsSSL' }),
          _react2.default.createElement(_FooterMicrocopy2.default, null)
        ),
        _react2.default.createElement(_PhoneSupportFooter2.default, {
          phoneSourceId: 'cms-footer',
          screen: _Tracking.SUBSCREENS.CMS
        })
      )
    )
  );
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    purchaseMotionRequestStatus: state.purchaseMotionRequestStatus
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _DocumentUtils.withDocumentTitle)(CmsPage, 'cms'));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/cms-page/CmsPage.js
// module id = 767
// module chunks = 3 4